module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/runtime.lex.v2-2020-08-07.paginators.json
// module id = 824
// module chunks = 1